module.exports = __webpack_public_path__ + "media/svg-new/simulado-ef20b47a.svg";